// extracted by mini-css-extract-plugin
module.exports = {"header-platforms-button":"header-platforms-button_header-platforms-button__xDYzU"};